module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/court-proceedings/coutr-proceeding-menu/coutr-proceeding-menu.component.html
// module id = ./src/app/court-proceedings/coutr-proceeding-menu/coutr-proceeding-menu.component.html
// module chunks = main